import React from 'react';
import { Trans } from 'react-i18next';
import {
  Button,
  Col,
  Row,
  Modal,
  Space,
} from 'antd';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';

import { FormLabel } from 'components/common';
import { Label } from 'components/common/styles';
import WarehouseSelector from 'components/Warehouse/WarehouseSelectBox';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

type Props = {
  closable?: boolean;
  onClose: Function;
  onSelect?: Function;
  saveAsDefaultWarehouse?: boolean;
  visible: boolean;
  title?: string;
};

const SelectWarehouseDialog = (props: Props) => {
  const { useState } = React;
  const [inited, setInited] = useState(false);
  const [isWarehouseChanged, setIsWarehouseChanged] = useState(false);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState<number>();
  const [selectedWarehouse, setSelectedWarehouse] = useState<StringKAnyVPair>();

  const dialogFooter = () => {
    return (
      <Row justify="end">
        <Space>
          {props.closable !== false && <Button
            onClick={onCancel}
          >
            <CloseOutlined />
            Cancel
          </Button>}
          <Button
            disabled={!isWarehouseChanged}
            onClick={onSave}
            type="primary"
          >
            <SaveOutlined />
            &nbsp;
            <Trans i18nKey="common.save" />
          </Button>
        </Space>
      </Row>
    );
  };

  const onCancel = () => {
    props.onClose();
  };

  const onSave = () => {
    if (selectedWarehouseId && selectedWarehouseId > 0 && selectedWarehouse) {
      if (props.saveAsDefaultWarehouse) {
        localStorage.setItem(
          LS_DEFAULT_WAREHOUSE_KEY,
          selectedWarehouse.id,
        );
        window.location.reload();
      } else if (props.onSelect) {
        props.onSelect(selectedWarehouse);
      }

      onCancel();
    }
  };

  const onSelectWarehouse = (whId: number, wh: StringKAnyVPair) => {
    //console.log('s', whId, wh);
    if (whId !== selectedWarehouseId) {
      setIsWarehouseChanged(true);
      setSelectedWarehouse(wh);
      setSelectedWarehouseId(whId);
    }
  };

  React.useEffect(() => {
    if (!inited) {
      const id = Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY));

      if (id > 0) setSelectedWarehouseId(id);

      setInited(true);
    }
  }, [inited]);

  return (<>
    <Modal
      //bodyStyle={deviceSettingDialogBodyStyle}
      centered
      closable={props.closable}
      destroyOnClose
      footer={dialogFooter()}
      keyboard={false}
      maskClosable={false}
      onCancel={onCancel}
      title={<Label theme={{ fontSize: '20px' }}>{props.title || 'Select Warehouse'}</Label>}
      visible={props.visible}
      width={600}
    >
      <Row align="middle">
        <Col span={6} style={{ paddingRight: 12, textAlign: 'right' }}>
          <FormLabel>Warehouse</FormLabel>
        </Col>
        <Col span={16}>
          <WarehouseSelector
            onChange={onSelectWarehouse}
            placeholder="Please select a warehouse"
            sortByCreateTime={true}
            value={selectedWarehouseId}
          />
        </Col>
      </Row>
    </Modal>
  </>);
};

export default SelectWarehouseDialog;
